import { LatLng } from '../types'
import { setCurrentLocation } from './setJobDetails'

export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION'

export interface SetCurrentLocationAction {
    type: typeof SET_CURRENT_LOCATION,
    payload: {
        coords?: LatLng
    }
}

export type ActionType = SetCurrentLocationAction

export class Actions {
    static setCurrentLocation(coords?: LatLng): SetCurrentLocationAction {
        return {
            type: SET_CURRENT_LOCATION,
            payload: {
                coords: coords
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/user.ts